import type { KitManifest } from '../../shared/discoverKits';

const manifest: KitManifest = {
    slug: 'network-list',
    context: 'size2mix',
    name: 'Liste des réseaux',
    description:
        "Page d'index Nemo : DataTable AG Grid de tous les réseaux de l'utilisateur (4 types : Hot water, Cold water, Steam, Condensate). Colonnes : Type / Network name / Creation date / Created by / Actions (4 icônes fixes). Création via modal simplifiée.",
    status: 'partial',
    owner: 'platform-team',
    tags: ['network-list', 'index', 'list', 'ag-grid', 'home', 'create-network'],
    nemoSources: [
        {
            label: 'Page racine',
            path: 'apps/frontend-next/src/ui/views/pages/network/NetworkList.tsx',
            note: "Composition DataTable + bouton 'Créer un réseau'. Colonnes : Type, Nom, Dates, Liens, Actions.",
        },
        {
            label: 'Hook de fetch',
            path: 'apps/frontend-next/src/ui/hooks/network/useFetchNetworksList.ts',
            note: 'Récupère la liste depuis le BFF.',
        },
        {
            label: 'Création',
            path: 'apps/frontend-next/src/ui/views/containers/CreateNetwork.tsx',
            note: 'Container de création d\'un nouveau réseau (formulaire + appel API).',
        },
        {
            label: 'Cell renderers',
            path: 'apps/frontend-next/src/ui/views/components/grid-table/TableContent/',
            note: 'NetworkTypeCellRenderer, NetworkActionsCellRenderer, LinksCellRender — patterns de cellule AG Grid.',
        },
        {
            label: 'Date formatter',
            path: 'apps/frontend-next/src/ui/views/components/date-formatter/DateFormatter.tsx',
            note: 'DateCellFormatter + DateCellFilterer (filtre par date dans AG Grid).',
        },
        {
            label: 'Modèle',
            path: 'apps/frontend-next/src/domain/models/Network.ts',
            note: 'INetworkList interface — structure d\'une ligne.',
        },
    ],
    sharedComponents: [
        '@shared/PrototypeStudioLayout',
        '@shared/DataTable (la table elle-même)',
        '@shared/EditableField (édition inline du nom dans la table)',
        '@shared/tag/* (badges de type de réseau : hot-water / cold-water / power)',
        '@shared/modal/CenterModal (modale de création réseau)',
        '@shared/dropdown/* (menu actions par ligne)',
    ],
    views: [
        {
            id: 'list-table',
            label: 'Liste — Table AG Grid',
            description:
                "Table principale : colonnes Type (badges colorés) / Network name / Creation date / Created by / Actions (4 icônes). Filtres et tri AG Grid standard.",
            prototypeSlug: 'ref-network-list',
            screenshot: 'screenshots/01-network-list-table.png',
        },
        {
            id: 'create-network-modal',
            label: 'Modale — Création de réseau',
            description:
                "Formulaire simple : textarea Network name (0/64 caractères) + dropdown Type (4 options). Boutons Cancel / Create.",
            prototypeSlug: 'ref-network-list',
            screenshot: 'screenshots/03-create-network-modal-empty.png',
        },
        {
            id: 'actions-icons',
            label: 'Ligne — Icônes d\'actions',
            description:
                "4 icônes fixes par ligne : Network editor, Optimisations, Copy, Detail. Tooltips au hover.",
            prototypeSlug: 'ref-network-list',
            screenshot: 'screenshots/02-network-list-actions-icons.png',
        },
        {
            id: 'type-cell',
            label: 'Cellule — Type de réseau',
            description:
                "Badge coloré : Hot water rouge, Cold water bleu, Steam orange, Condensate violet.",
            prototypeSlug: 'ref-network-list',
        },
    ],
    notes: `
- ✅ Conforme aux screenshots réels Nemo (7 screenshots dans src/kits/network-list/screenshots/)
- 4 types de réseau : hot-water, cold-water, steam, condensate (pas power)
- Colonnes simplifiées : Type / Network name / Creation date / Created by / Actions
- Actions = 4 icônes fixes (Network editor, Optimisations, Copy, Detail) — PAS de dropdown menu
- Modal création simplifiée : juste textarea nom + dropdown type — PAS de champs conditionnels
- Pattern AG Grid : voir copilot-instructions.md règle DataTable
  (valueFormatter pour l'affichage, jamais valueGetter qui casse les filtres)
- Badges colorés : Hot water (#d32f2f), Cold water (#1976d2), Steam (#f57c00), Condensate (#9c27b0)
`.trim(),
};

export default manifest;
